import styled from 'styled-components';

import { $dmSansFontFamily, $robotoFontFamily, colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Button } from '../Button';

export const StyledDisabledImage = styled.img`
  margin: -3px 0 91px 33px;
  min-height: 228px;
`;

export const StyledDisabledSettingHeading = styled.h1`
  margin: 6px 0 18px;
  font-family: ${$dmSansFontFamily};
  font-weight: 700;
  font-size: 28px;
  color: ${colorsPalettes.carbon[400]};
  letter-spacing: -0.005em;
`;

export const StyledDisabledSettingText = styled.p`
  margin: 0 0 40px 0;
  text-align: center;
  ${setFontVariant('subsectionTitle', colorsPalettes.carbon[300])};
  font-weight: 400;
`;

export const StyledDisabledSettingNew = styled.div`
  text-transform: uppercase;
  font-family: ${$robotoFontFamily};
  color: ${colorsPalettes.carbon[400]};
  font-weight: 500;
  font-size: 10px;
  line-height: 8px;
  letter-spacing: 0.6px;
`;

export const StyledEnableButton = styled(Button)`
  font-size: 16px;
  min-width: 180px;
  min-height: 42px;
  border-radius: 20px;
`;
